import { render, staticRenderFns } from "./setBar.vue?vue&type=template&id=7fa2dc5c&scoped=true"
import script from "./setBar.vue?vue&type=script&lang=js"
export * from "./setBar.vue?vue&type=script&lang=js"
import style0 from "./setBar.vue?vue&type=style&index=0&id=7fa2dc5c&prod&lang=less&scoped=true"
import style1 from "./setBar.vue?vue&type=style&index=1&id=7fa2dc5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.2__lodash@4_b4c53c95ade375b15f87fdb8d4d02a8b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa2dc5c",
  null
  
)

export default component.exports